import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/detailsPopup/styles.scss';export default {
  "resizePopup": "_resizePopup_1u2pv_1",
  "popup": "_popup_1u2pv_7",
  "name": "_name_1u2pv_19",
  "text": "_text_1u2pv_26",
  "label": "_label_1u2pv_32"
};